import React from 'react';
import { ViewStyle, StyleProp } from 'react-native';
import { iconMap } from '@/components/NeolexonIcon/Icons/';
import { IconName } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';

type NeolexonIconProps = {
  name: IconName;
  isInverted?: boolean;
  size?: number;
  color?: string;
  style?: StyleProp<ViewStyle>;
  fillColor?: string;
};

export const NeolexonIcon = ({
  name,
  isInverted,
  size = 24,
  color = colors.newUI.therapist.primaryBlue80,
  style,
  fillColor,
  ...props
}: NeolexonIconProps) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      size={size}
      isInverted={isInverted}
      color={color}
      fillColor={fillColor ?? color}
      style={style}
      {...props}
    />
  );
};
